// src/store/slices/orderSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import orderApi from "api/orderApi";

const getCurrentEmployeeId = () => {
  try {
    const employee = JSON.parse(localStorage.getItem("employee") || "{}");
    return employee?.id || null;
  } catch {
    return null;
  }
};

// export const fetchOrders = createAsyncThunk(
//   "order/fetchOrders",
//   async ({ page = 1, pageSize = 10, search = "" }, { rejectWithValue }) => {
//     try {
//       const data = await orderApi.getAll(page, pageSize, search);
//       console.warn("calling order", data);
//       return data;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.detail || "Failed to load orders"
//       );
//     }
//   }
// );

// export const fetchOrders = createAsyncThunk(
//   "order/fetchOrders",
//   async (
//     { page = 1, pageSize = 10, search = "" } = {},
//     { rejectWithValue }
//   ) => {
//     try {
//       // Only pass employee ID on Canteen page (this thunk is used in multiple places)
//       // We detect via pageSize — Canteen uses 1000, others use 10–50
//       const isCanteenPage = pageSize >= 200;

//       const employeeId = isCanteenPage ? getCurrentEmployeeId() : null;

//       const data = await orderApi.getAll(page, pageSize, search, employeeId);
//       return data;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.detail || "Failed to load orders"
//       );
//     }
//   }
// );

export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, pageSize = 10, search = "", ...restFilters } = params;

      const isCanteenPage = pageSize >= 200;
      const employeeId = isCanteenPage ? getCurrentEmployeeId() : null;

      const data = await orderApi.getAll({
        page,
        page_size: pageSize,
        search,
        employee: employeeId,
        ...restFilters,
      });
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to load orders"
      );
    }
  }
);

export const placeOrder = createAsyncThunk(
  "order/placeOrder",
  async (items, { rejectWithValue }) => {
    try {
      const data = await orderApi.placeOrder(items);
      return data;
    } catch (err) {
      console.log("eeee", err.response?.data?.items);
      return rejectWithValue(
        err.response?.data?.items || "Failed to place order"
      );
    }
  }
);

// export const cancelOrder = createAsyncThunk(
//   "order/cancelOrder",
//   async (id, { rejectWithValue }) => {
//     try {
//       await orderApi.cancelOrder(id);
//       return id;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.detail || "Cannot cancel order"
//       );
//     }
//   }
// );

// src/store/slices/orderSlice.js

export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async ({ id, reason }, { rejectWithValue }) => {
    // ← Destructure { id, reason }
    try {
      // Pass both id and reason to API
      await orderApi.cancelOrder(id, reason);
      return id; // still return id for reducer
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail ||
          err.response?.data?.reason ||
          "Cannot cancel order"
      );
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const data = await orderApi.updateStatus(id, status);
      return { id, status: data.status };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to update status"
      );
    }
  }
);

export const submitFeedback = createAsyncThunk(
  "order/submitFeedback",
  async ({ id, rating, comment }, { rejectWithValue }) => {
    try {
      await orderApi.submitFeedback(id, rating, comment);
      return id;
    } catch (err) {
      console.log("error", err);
      return rejectWithValue(
        err.response?.data?.non_field_errors || "Failed to submit feedback"
      );
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "order/deleteOrder",
  async (id, { rejectWithValue }) => {
    try {
      await orderApi.deleteOrder(id);
      return id;
    } catch (err) {
      return rejectWithValue("Failed to delete order");
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    stats: {
      pending: 0,
      preparing: 0,
      ready: 0,
      delivered: 0,
      cancelled: 0,
      total: 0,
      total_revenue: 0,
      today_total: 0,
      today_total_pending: 0,
      today_total_preparing: 0,
      today_total_ready: 0,
      today_total_delivered: 0,
      today_total_cancelled: 0,
      today_revenue: 0,
      monthly_total: 0,
      monthly_total_cancelled: 0,
      monthly_total_delivered: 0,
      monthly_revenue: 0,
    },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },

    // setOrders: (state, action) => {
    //   const payload = action.payload;
    //   state.orders = action.payload.orders || action.payload;
    //   // state.pagination = action.payload.pagination || {
    //   //   count: state.orders.length,
    //   //   page_size: state.orders.length,
    //   // };
    //   if (payload.stats) {
    //     state.stats = payload.stats;
    //   }
    //   state.isLoading = false;
    // },

    setOrders: (state, action) => {
      const { orders = [], stats } = action.payload;

      state.orders = orders;
      if (stats) state.stats = stats;
      // if (pagination) state.pagination = pagination;
      // else {
      //   state.pagination = {
      //     count: orders.length,
      //     page_size: orders.length,
      //     next: null,
      //     previous: null,
      //   };
      // }
    },

    // This is the KEY — same as setRealtimeTickets
    // setRealtimeOrders: (state, action) => {
    //   const incoming = action.payload;

    //   // Handle both single object and array (just like ticketSlice)
    //   const ordersToProcess = Array.isArray(incoming) ? incoming : [incoming];

    //   ordersToProcess.forEach(order => {
    //     if (!order?.id) return;

    //     const index = state.orders.findIndex(o => o.id === order.id);

    //     if (index !== -1) {
    //       // Update existing order (status change, etc.)
    //       state.orders[index] = { ...state.orders[index], ...order };
    //     }
    //     // DO NOT add new orders here if not in current page
    //     // → Only update if already visible (prevents breaking pagination)
    //   });
    // },

    // src/store/slices/orderSlice.js

    // setRealtimeOrders: (state, action) => {
    //   const incoming = action.payload;

    //   // Handle both single order and array (from initial_state, etc.)
    //   const orders = Array.isArray(incoming) ? incoming : [incoming];

    //   orders.forEach(order => {
    //     if (!order?.id) return;

    //     const existsIndex = state.orders.findIndex(o => o.id === order.id);

    //     if (existsIndex !== -1) {
    //       // Order already in current page → update it
    //       state.orders[existsIndex] = { ...state.orders[existsIndex], ...order };
    //     } else {
    //       // NEW ORDER → add to top (most important!)
    //       // Only if it's active (not delivered/cancelled)
    //       if (!["delivered", "cancelled"].includes(order.status)) {
    //         state.orders.unshift(order);
    //         state.pagination.count += 1; // important!
    //       }
    //     }
    //   });
    // },

    // Inside your orderSlice reducers
    // setRealtimeOrders: (state, action) => {
    //   const incoming = action.payload;
    //   const orders = Array.isArray(incoming) ? incoming : [incoming];

    //   orders.forEach((order) => {
    //     if (!order?.id) return;

    //     const existsIndex = state.orders.findIndex((o) => o.id === order.id);

    //     if (existsIndex !== -1) {
    //       // Update existing
    //       state.orders[existsIndex] = {
    //         ...state.orders[existsIndex],
    //         ...order,
    //       };
    //     } else {
    //       // NEW ORDER → add to top if active
    //       // if (!["delivered", "cancelled"].includes(order.status?.toLowerCase())) {
    //       //   state.orders.unshift(order);
    //       //   state.pagination.count += 1;
    //       // }
    //     }
    //   });
    // },

    // Inside orderSlice reducers
    setRealtimeOrders: (state, action) => {
      const incoming = action.payload;
      const ordersToProcess = Array.isArray(incoming) ? incoming : [incoming];

      ordersToProcess.forEach((order) => {
        if (!order?.id) return;

        const existsIndex = state.orders.findIndex((o) => o.id === order.id);

        if (existsIndex !== -1) {
          // Update existing order (status changed, etc.)
          state.orders[existsIndex] = {
            ...state.orders[existsIndex],
            ...order,
          };
        } else {
          // THIS IS THE MISSING PART → ADD NEW ORDER!
          state.orders.unshift(order);
          state.pagination.count += 1;
        }
      });

      // Optional: Keep list sorted by newest first
      state.orders.sort(
        (a, b) => new Date(b.order_time) - new Date(a.order_time)
      );
    },

    // updateOrderInList: (state, action) => {
    //   const updatedOrder = action.payload;
    //   const index = state.orders.findIndex(o => o.id === updatedOrder.id);
    //   if (index !== -1) {
    //     state.orders[index] = { ...state.orders[index], ...updatedOrder };
    //   }
    // },
    //     updateOrderInList: (state, action) => {
    //   const updated = action.payload;
    //   const index = state.orders.findIndex(o => o.id === updated.id);
    //   if (index !== -1) {
    //     state.orders[index] = { ...state.orders[index], ...updated };
    //   } else {
    //     // Optional: add new order if not in list (e.g. new order while on page 2)
    //     state.orders.unshift(updated);
    //     state.pagination.count += 1;
    //   }
    // },

    updateOrderInList: (state, action) => {
      const updated = action.payload;
      const index = state.orders.findIndex((o) => o.id === updated.id);

      if (index !== -1) {
        // Update existing
        state.orders[index] = { ...state.orders[index], ...updated };
      } else {
        // Add new order (e.g. just placed)
        state.orders.unshift(updated);
        state.pagination.count += 1;
      }
    },

    // addNewOrderRealtime: (state, action) => {
    //     const order = action.payload;
    //     if (!order?.id) return;

    //     const exists = state.orders.some(o => o.id === order.id);
    //     if (exists) return;

    //     if (!["delivered", "cancelled"].includes(order.status)) {
    //       state.orders.unshift(order);
    //       state.pagination.count += 1;
    //     }
    //   },

    //   // Updates existing order in place (status, items, etc.)
    //   updateOrderInList: (state, action) => {
    //     const updatedOrder = action.payload;
    //     if (!updatedOrder?.id) return;

    //     const index = state.orders.findIndex(o => o.id === updatedOrder.id);
    //     if (index !== -1) {
    //       state.orders[index] = { ...state.orders[index], ...updatedOrder };

    //       // Optional: Remove delivered/cancelled from active list
    //       if (["delivered", "cancelled"].includes(updatedOrder.status)) {
    //         state.orders.splice(index, 1);
    //         state.pagination.count = Math.max(0, state.pagination.count - 1);
    //       }
    //     }
    //   },

    removeOrderFromList: (state, action) => {
      state.orders = state.orders.filter((o) => o.id !== action.payload);
      state.pagination.count = state.orders.length;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orders = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        const order = state.orders.find((o) => o.id === action.payload);
        if (order) order.status = "cancelled";
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const order = state.orders.find((o) => o.id === action.payload.id);
        if (order) order.status = action.payload.status;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.orders = state.orders.filter((o) => o.id !== action.payload);
        state.pagination.count -= 1;
      });
  },
});

export const {
  clearError,
  setOrders,
  addNewOrderRealtime,
  setRealtimeOrders,
  updateOrderInList,
  removeOrderFromList,
} = orderSlice.actions;
export default orderSlice.reducer;
